var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLight = function SvgArrowLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 15.727a.73.73 0 0 1-.71.742c-.384 0-.704-.344-.704-.711v-2.89l.14-3.65-1.288 1.462-7.758 7.75a.66.66 0 0 1-.492.21.75.75 0 0 1-.727-.726.7.7 0 0 1 .219-.492l7.742-7.758 1.453-1.273-3.812.125h-2.72c-.366 0-.702-.32-.702-.696s.297-.71.734-.71h7.86c.468 0 .757.312.757.757z"
  })));
};
export default SvgArrowLight;